import React from "react";

const Resume = () => {
  return (
    <section id="about">
      <div>
        <div className="row">
          <div className="col-lg-10 px-5 text-left text-lg-start wow fadeInUp ">
            <h2 className="text-8 fw-400 mb-3 mt-5 ">
              <span className="fw-700 text-primary border-3 border-primary offset-lg-1">
                Learning Objectives
              </span>
            </h2>

            <p className="text-5 offset-lg-1 text-justify">
              Upon completion of the course, participants will be able to:
            </p>
            <ul className="text-5 offset-lg-1 text-justify">
              <li>
                Interpret current clinical data in order to optimize the
                treatment of patients with SHD.
              </li>
              <li>Recognize basic views of fluoroscopy.</li>
              <li>
                Analyze 2D and 3D echocardiography with a comprehensive approach
                to the assessment of the aortic, mitral, and tricuspid valves,
                the interatrial septum, and the left/right ventricles.
              </li>
              <li>
                Identify normal and abnormal non coronary cardiac anatomy.
              </li>
              <li>
                Summarize the steps for post-processing analysis for TAVR.
              </li>
              <li>Recognize novel techniques associated with SHDs.</li>
              <li>
                Understand the interventional skills for percutaneous
                transseptal puncture using appropriate transseptal sheaths,
                wires, needles, and other access devices.
              </li>
              <li>Identify the echocardiographic steps for different SHDs.</li>
              <li>
                Employ the best clinical anesthetic practices and be able to
                manage potential complications of catheter-based therapies for
                SHD.
              </li>
            </ul>

            <h2 className="text-8 fw-200 mb-2 mt-2 ">
              <span className="fw-700 text-primary offset-lg-1">
                Accreditation
              </span>
            </h2>
            <p className="text-5 offset-lg-1 text-justify">
              The Harvard Medical School is accredited by the Accreditation
              Council for Continuing Medical Education to provide continuing
              medical education for physicians. The Harvard Medical School
              designates this live activity for a maximum of 23.75 AMA PRA
              Category 1 Credits. Physicians should claim only the credit
              commensurate with the extent of their participation in the
              activity.
            </p>
          </div>
          <div
            className="col-lg-2 mt-4 mt-lg-0 wow fadeInUp text-center"
            data-wow-delay="0.2s"
            style={{ backgroundColor: "#D9D9D9" }}
          >
            <h2 className="text-4 fw-300 mt-3">
              <span
                style={{ color: "black", textAlign: "center" }}
                className="fw-700 border-3 border-primary"
              >
                <em>Course</em>
              </span>
            </h2>
            <h2 className="text-4 fw-400 " style={{ textAlign: "center" }}>
              <span
                style={{ color: "#AE2A2F" }}
                className="fw-700 border-3 border-primary"
              >
                <em>Coordinators</em>
              </span>
            </h2>
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500">
                <img
                  className="img-fluid rounded-pill d-block"
                  src="images/images/Course Coordinators/Taha A. Rehman.png"
                  alt=""
                />
              </div>
              <h3 className="text-3 wow rubberBand" data-wow-delay="2s">
                Taha A. Rehman, MD
              </h3>
              <div className="featured-box-icon text-25 fw-500">
                <img
                  className="img-fluid rounded-pill d-block"
                  src="images/images/Course Coordinators/Rayaan A. Yunus.png"
                  alt=""
                />
              </div>
              <h4 className="text-3 wow rubberBand" data-wow-delay="2s">
                Rayaan A. Yunus, BA
              </h4>
              <div className="featured-box-icon text-25 fw-500">
                <img
                  className="img-fluid rounded-pill d-block"
                  src="images/images/Course Coordinators/Adnan A. Khan.png"
                  alt=""
                />
              </div>
              <h3 className="text-3 wow rubberBand" data-wow-delay="2s">
                Adnan A. Khan, MD
              </h3>
              <div className="featured-box-icon text-25 fw-500">
                <img
                  className="img-fluid rounded-pill d-block"
                  src="images/images/Course Coordinators/Yifan Bu.png"
                  alt="Italian Trulli"
                />
              </div>
              <h3 className="text-3 wow rubberBand" data-wow-delay="2s">
                Yifan Bu, MD
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
